import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { useState } from "react";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { useApi } from "../../customer/hooks";

// Green/red SoftOne connection pill for admins; "check" forces a fresh login
export const SoftOneBadge = () => {
  const { t } = useI18n();
  const r = useApi("softoneBadge", "/admin/softone/badge", undefined, { staleTime: 0, refetchInterval: 120000 });
  const [busy, setBusy] = useState(false);
  if (!r.data) return null;
  const ok = r.data.connected;
  const check = async () => { setBusy(true); try { await api.post("/admin/softone/login"); } catch (e) { /* shown by badge */ } await r.refetch(); setBusy(false); };
  return (
    <div className={`flex flex-wrap items-center gap-2 rounded-2xl px-4 py-3 text-sm shadow-sm ${ok ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-800"}`} data-testid="softone-badge" data-connected={ok ? "true" : "false"}>
      <span className={`h-2.5 w-2.5 rounded-full ${ok ? "bg-emerald-500" : "bg-red-500 animate-pulse"}`} />
      <Link to="/staff/softone" className="font-semibold hover:underline" data-testid="softone-badge-status">{ok ? t("x.dash.s1Ok") : r.data.configured ? t("x.dash.s1Down") : t("x.dash.s1NotConfigured")}</Link>
      {!ok && r.data.last_error && r.data.configured && <span className="min-w-0 flex-1 truncate text-xs opacity-80" data-testid="softone-badge-error">{r.data.last_error}</span>}
      <button type="button" onClick={check} disabled={busy} className="ml-auto flex h-8 items-center gap-1 rounded-full bg-white/70 px-3 text-xs font-medium hover:bg-white disabled:opacity-50" data-testid="softone-badge-check">
        <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /> {t("x.dash.s1Check")}
      </button>
    </div>
  );
};
